<!-- <div class="upload-container" (click)="fileInput.click()" title="{{'Attach PDF' | translate | async}}">
  <i class="material-icons upload-container__icon">
    add_a_photo
  </i>
  <label>             
    <input type="file" #fileUploader  name="upload" accept="application/pdf,application/vnd.ms-excel" (change)="onFileChanged($event);">       
  </label>
</div>
<mat-spinner diameter="24" *ngIf="photoLoading"></mat-spinner> -->


<div class="Dialog-body">              
  <label>             
    <input type="file" #fileUploader  name="upload" [accept]="acceptedTypes" (change)="onFileChanged($event);">       
  </label>
  <div class="buttonbelow">         
    <button mat-raised-button (click)="DialogClose()">Cancel</button>
      <button mat-raised-button color="warn" (click)="submitFilePreview()">
        <i class="material-icons button__icon">save</i><span class="button__text">
          Save
        </span>
      </button>
  </div>
</div>
